<template>
  <div id="regua-disparos-page" class="apple-page-container">
    <!-- Header Principal Apple Expandido -->
    <header class="apple-main-card mb-4">
      <div class="apple-header-row">
        <div class="apple-title-box">
          <div class="flex items-center gap-3">
            <h1 class="apple-main-title">Régua de Mensagens</h1>
            <span class="apple-pill-tag">WATI WhatsApp & E-mail</span>
          </div>
          <p class="apple-main-subtitle">
            Configure os gatilhos, horários de execução automática e templates para Pós-Venda e Cobrança
          </p>
        </div>

        <div class="apple-header-actions">
          <!-- Link para Assuntos -->
          <router-link
            to="/assunto"
            target="_blank"
            class="apple-btn apple-btn-secondary"
            title="Ir para Assuntos (Configurar Gatilhos e Ativação de Chamados/NPS - Nova Aba)"
          >
            <feather-icon icon="ListIcon" svgClasses="w-4 h-4 text-gray-500" />
            <span>Gatilhos em Assuntos</span>
          </router-link>

          <!-- Link para Parâmetros WATI -->
          <router-link
            to="/parametro"
            target="_blank"
            class="apple-btn apple-btn-secondary"
            title="Ir para Parâmetros do Sistema e Configurações WATI (Nova Aba)"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4 text-gray-500" />
            <span>Parâmetros WATI</span>
          </router-link>

          <button
            type="button"
            class="apple-btn apple-btn-secondary"
            @click="abrirSimulacaoGeral"
            title="Simular régua completa com data de referência"
          >
            <feather-icon icon="PlayIcon" svgClasses="w-4 h-4 text-blue-600" />
            <span>Simular Régua</span>
          </button>

          <button
            type="button"
            class="apple-btn apple-btn-primary"
            @click="abrirNovaRegra"
          >
            <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
            <span>{{ abaAtiva === 0 ? 'Nova Regra Pós-Venda' : (abaAtiva === 1 ? 'Nova Regra Cobrança' : 'Nova Regra') }}</span>
          </button>
        </div>
      </div>

      <!-- SKELETON STATE PARA KPI CARDS -->
      <div v-if="carregando && regras.length === 0" class="apple-kpi-grid mt-6">
        <div v-for="n in 4" :key="'skel-kpi-' + n" class="apple-kpi-card skeleton-card">
          <div class="apple-kpi-header">
            <div class="skeleton-shimmer skeleton-line w-24 h-3 rounded"></div>
            <div class="skeleton-shimmer skeleton-circle w-8 h-8 rounded-lg"></div>
          </div>
          <div class="apple-kpi-body">
            <div class="skeleton-shimmer skeleton-line w-12 h-8 rounded mt-1"></div>
            <div class="skeleton-shimmer skeleton-line w-20 h-4 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Grid de Cards de Resumo Grandes (KPIs) -->
      <div v-else class="apple-kpi-grid mt-6">
        <!-- Card 1: Pós-Venda -->
        <div class="apple-kpi-card" :class="{ 'kpi-card-active': abaAtiva === 0 }" @click="abaAtiva = 0">
          <div class="apple-kpi-header">
            <span class="apple-kpi-title">Régua Pós-Venda</span>
            <div class="apple-kpi-icon bg-purple-50 text-purple-600 border border-purple-100">
              <feather-icon icon="CheckCircleIcon" svgClasses="w-4 h-4" />
            </div>
          </div>
          <div class="apple-kpi-body">
            <span class="apple-kpi-number">{{ regrasPosVenda.length }}</span>
            <div class="apple-kpi-desc">
              <span class="kpi-status-badge badge-active font-semibold">{{ totalAtivasPosVenda }} ativas</span>
              <span class="kpi-status-badge badge-inactive">· {{ regrasPosVenda.length - totalAtivasPosVenda }} inativas</span>
            </div>
          </div>
        </div>

        <!-- Card 2: Cobrança -->
        <div class="apple-kpi-card" :class="{ 'kpi-card-active': abaAtiva === 1 }" @click="abaAtiva = 1">
          <div class="apple-kpi-header">
            <span class="apple-kpi-title">Régua Cobrança</span>
            <div class="apple-kpi-icon bg-emerald-50 text-emerald-600 border border-emerald-100">
              <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4" />
            </div>
          </div>
          <div class="apple-kpi-body">
            <span class="apple-kpi-number">{{ regrasCobranca.length }}</span>
            <div class="apple-kpi-desc">
              <span class="kpi-status-badge badge-active font-semibold">{{ totalAtivasCobranca }} ativas</span>
              <span class="kpi-status-badge badge-inactive">· {{ regrasCobranca.length - totalAtivasCobranca }} inativas</span>
            </div>
          </div>
        </div>

        <!-- Card 3: Histórico de Jobs -->
        <div class="apple-kpi-card" :class="{ 'kpi-card-active': abaAtiva === 2 }" @click="abaAtiva = 2">
          <div class="apple-kpi-header">
            <span class="apple-kpi-title">Histórico de Jobs</span>
            <div class="apple-kpi-icon bg-indigo-50 text-indigo-600 border border-indigo-100">
              <feather-icon icon="ClockIcon" svgClasses="w-4 h-4" />
            </div>
          </div>
          <div class="apple-kpi-body">
            <span class="apple-kpi-number">{{ historicoJobs.length }}</span>
            <div class="apple-kpi-desc">
              <span class="font-semibold text-indigo-600">Execuções registradas</span>
            </div>
          </div>
        </div>

        <!-- Card 4: Templates WATI -->
        <div class="apple-kpi-card" @click="carregarTemplatesWati" title="Clique para sincronizar templates WATI">
          <div class="apple-kpi-header">
            <span class="apple-kpi-title">Templates WATI</span>
            <div class="apple-kpi-icon bg-blue-50 text-blue-600 border border-blue-100">
              <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            </div>
          </div>
          <div class="apple-kpi-body">
            <span class="apple-kpi-number">{{ templatesWati.length }}</span>
            <div class="apple-kpi-desc">
              <span v-if="carregandoTemplates" class="font-medium text-blue-600 flex items-center gap-1">
                <feather-icon icon="RefreshCwIcon" svgClasses="w-3 h-3 animate-spin" />
                Sincronizando...
              </span>
              <span v-else class="font-medium text-gray-500">
                Aprovados no WATI
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Barra de Controle do Robô de Automação Diária em Background -->
      <div class="apple-robot-bar mt-5">
        <div class="apple-robot-content">
          <!-- Lado Esquerdo: Identificação e Status do Robô -->
          <div class="apple-robot-info">
            <div 
              class="apple-robot-icon" 
              :class="configAutomatica.ativo ? 'robot-icon-active' : 'robot-icon-inactive'"
            >
              <feather-icon icon="CpuIcon" svgClasses="w-5 h-5" />
            </div>
            
            <div class="apple-robot-texts">
              <div class="apple-robot-title-row">
                <span class="apple-robot-name">Robô Automático da Régua</span>
                
                <!-- Badge de Status Ativo / Desativado Refinado com Ícone e Pulso -->
                <div 
                  class="robot-status-pill"
                  :class="configAutomatica.ativo ? 'status-pill-active' : 'status-pill-inactive'"
                >
                  <span class="status-pulse-dot" :class="configAutomatica.ativo ? 'pulse-green' : 'pulse-gray'"></span>
                  <feather-icon 
                    :icon="configAutomatica.ativo ? 'CheckCircleIcon' : 'PauseCircleIcon'" 
                    svgClasses="w-3.5 h-3.5" 
                  />
                  <span>{{ configAutomatica.ativo ? 'Robô Ativo (Agendado)' : 'Robô Pausado / Desativado' }}</span>
                </div>
              </div>
              
              <div class="apple-robot-desc">
                Executa a verificação e o disparo diário em segundo plano sem necessidade de clique manual.
              </div>
            </div>
          </div>

          <!-- Lado Direito: Parâmetros e Ação de Salvar -->
          <div class="apple-robot-controls">
            <div class="robot-input-group">
              <label class="robot-input-label">
                <feather-icon icon="ClockIcon" svgClasses="w-3.5 h-3.5 text-gray-400" />
                <span>Horário:</span>
              </label>
              <input
                type="time"
                v-model="configAutomatica.horario"
                class="apple-time-input"
                title="Horário diário em que o robô acorda para disparar"
              />
            </div>

            <div class="robot-input-group">
              <label class="robot-input-label">
                <feather-icon icon="CalendarIcon" svgClasses="w-3.5 h-3.5 text-gray-400" />
                <span>Frequência:</span>
              </label>
              <select v-model="tipoFrequencia" class="apple-select-input">
                <option value="uteis_sem_feriados">Seg a Sex (Excluir Feriados)</option>
                <option value="uteis">Dias Úteis (Seg a Sex)</option>
                <option value="todos">Todos os Dias (Seg a Dom)</option>
              </select>
            </div>

            <div class="robot-switch-wrapper">
              <vs-switch
                v-model="configAutomatica.ativo"
                color="success"
                title="Ativar ou desativar o disparo automático diário"
              />
            </div>

            <button
              type="button"
              class="apple-btn apple-btn-save-robot"
              :disabled="salvandoConfigAutomatica"
              @click="salvarConfigAutomatica"
            >
              <feather-icon 
                :icon="salvandoConfigAutomatica ? 'RefreshCwIcon' : 'CheckIcon'" 
                svgClasses="w-3.5 h-3.5" 
                :class="{ 'animate-spin': salvandoConfigAutomatica }"
              />
              <span>{{ salvandoConfigAutomatica ? 'Salvando...' : 'Salvar Robô' }}</span>
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Toolbar: Segmented Tabs + Ações -->
    <div class="apple-toolbar-row mb-3">
      <div class="apple-segmented-bar">
        <button
          type="button"
          class="apple-tab-button"
          :class="{ 'active': abaAtiva === 0 }"
          @click="abaAtiva = 0"
        >
          <feather-icon icon="CheckCircleIcon" svgClasses="w-3.5 h-3.5 mr-1.5 inline" />
          <span>Pós-Venda</span>
          <span class="apple-count-pill">{{ regrasPosVenda.length }}</span>
        </button>

        <button
          type="button"
          class="apple-tab-button"
          :class="{ 'active': abaAtiva === 1 }"
          @click="abaAtiva = 1"
        >
          <feather-icon icon="DollarSignIcon" svgClasses="w-3.5 h-3.5 mr-1.5 inline" />
          <span>Cobrança</span>
          <span class="apple-count-pill">{{ regrasCobranca.length }}</span>
        </button>

        <button
          type="button"
          class="apple-tab-button"
          :class="{ 'active': abaAtiva === 2 }"
          @click="abaAtiva = 2"
        >
          <feather-icon icon="ClockIcon" svgClasses="w-3.5 h-3.5 mr-1.5 inline" />
          <span>Histórico de Jobs</span>
          <span class="apple-count-pill">{{ historicoJobs.length }}</span>
        </button>
      </div>

      <div class="apple-toolbar-actions">
        <button
          type="button"
          class="apple-refresh-btn"
          title="Recarregar dados da régua"
          :disabled="carregando"
          @click="recarregarTudo"
        >
          <feather-icon icon="RefreshCwIcon" svgClasses="w-3.5 h-3.5 text-gray-500" :class="{ 'animate-spin': carregando }" />
          <span class="text-xs text-gray-700 font-medium">Recarregar</span>
        </button>
      </div>
    </div>

    <!-- Conteúdo Principal / Tabelas -->
    <main class="apple-main-card">
      <!-- SKELETON LOADING STATE PARA TABELA -->
      <div v-if="carregando" class="apple-table-skeleton-container">
        <div class="skeleton-table-header">
          <div class="skeleton-shimmer skeleton-line w-40 h-4 rounded"></div>
          <div class="skeleton-shimmer skeleton-line w-28 h-4 rounded"></div>
          <div class="skeleton-shimmer skeleton-line w-28 h-4 rounded"></div>
          <div class="skeleton-shimmer skeleton-line w-24 h-4 rounded"></div>
          <div class="skeleton-shimmer skeleton-line w-16 h-4 rounded"></div>
        </div>
        <div v-for="i in 4" :key="'skel-row-' + i" class="skeleton-table-row">
          <div class="flex items-center gap-3 w-1/3">
            <div class="skeleton-shimmer skeleton-circle w-9 h-9 rounded-lg"></div>
            <div class="flex-1 space-y-1.5">
              <div class="skeleton-shimmer skeleton-line w-48 h-3.5 rounded"></div>
              <div class="skeleton-shimmer skeleton-line w-28 h-2.5 rounded"></div>
            </div>
          </div>
          <div class="skeleton-shimmer skeleton-pill w-28 h-6 rounded-full"></div>
          <div class="skeleton-shimmer skeleton-line w-36 h-3.5 rounded"></div>
          <div class="skeleton-shimmer skeleton-pill w-32 h-6 rounded-full"></div>
          <div class="flex items-center gap-2">
            <div class="skeleton-shimmer skeleton-circle w-8 h-8 rounded-lg"></div>
            <div class="skeleton-shimmer skeleton-circle w-8 h-8 rounded-lg"></div>
          </div>
        </div>
      </div>

      <!-- ================= ABA 1: PÓS-VENDA ================= -->
      <div v-else-if="abaAtiva === 0">
        <!-- Empty State Pós-Venda -->
        <div v-if="regrasPosVenda.length === 0" class="apple-empty-container">
          <div class="apple-empty-circle">
            <feather-icon icon="InboxIcon" svgClasses="w-8 h-8 text-gray-400" />
          </div>
          <h3 class="apple-empty-heading">Nenhuma regra de pós-venda configurada</h3>
          <p class="apple-empty-paragraph">
            Configure gatilhos para enviar mensagens automáticas após a execução dos serviços (ex: 5 dias após a 5ª OS).
          </p>
          <button
            type="button"
            class="apple-btn apple-btn-primary mt-4"
            @click="abrirModalPosVenda(null)"
          >
            <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
            <span>Adicionar Primeira Regra</span>
          </button>
        </div>

        <!-- Tabela Pós-Venda -->
        <div v-else class="apple-table-scroll">
          <table class="apple-spacious-table">
            <thead>
              <tr>
                <th style="width: 25%;">Regra / Identificação</th>
                <th style="width: 15%;">Sequência da OS</th>
                <th style="width: 16%;">Gatilho de Envio</th>
                <th style="width: 18%;">Próximo Disparo</th>
                <th style="width: 14%;">Template WATI</th>
                <th style="width: 6%; text-align: center;">Status</th>
                <th style="width: 6%; text-align: right;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="regra in regrasPosVenda" :key="regra.id" class="apple-table-item">
                <td>
                  <div class="apple-item-title">{{ regra.nome }}</div>
                  <div v-if="regra.equipes" class="apple-item-sub">
                    <feather-icon icon="UsersIcon" svgClasses="w-3 h-3 mr-1 inline text-gray-400" />
                    {{ regra.equipes }}
                  </div>
                </td>
                <td>
                  <span v-if="regra.sequencia_os" class="apple-pill-badge badge-purple">
                    {{ regra.sequencia_os }}ª OS do Cliente
                  </span>
                  <span v-else class="apple-pill-badge badge-gray">
                    Qualquer OS (Todas)
                  </span>
                </td>
                <td>
                  <div class="flex items-center text-gray-700 font-medium" style="gap: 8px;">
                    <feather-icon icon="ClockIcon" svgClasses="w-4 h-4 text-slate-400 shrink-0" />
                    <span>{{ regra.dias_apos_execucao }} dia(s) após execução</span>
                  </div>
                </td>
                <td>
                  <div v-if="configAutomatica.ativo && regra.ativo">
                    <div class="flex items-center text-slate-800 font-semibold text-xs" style="gap: 6px;">
                      <feather-icon icon="ZapIcon" svgClasses="w-3.5 h-3.5 text-emerald-500 shrink-0" />
                      <span>{{ calcularProximoDisparoRegra(regra).quandoTexto }}</span>
                      <span class="apple-pill-badge badge-green text-xxs" style="padding: 1px 6px;">
                        {{ calcularProximoDisparoRegra(regra).tempoFalta }}
                      </span>
                    </div>
                    <div class="text-slate-500 text-xxs mt-1">
                      {{ calcularProximoDisparoRegra(regra).alvoDescricao }}
                    </div>
                  </div>
                  <div v-else class="text-slate-400 text-xs flex items-center gap-1">
                    <feather-icon icon="PauseCircleIcon" svgClasses="w-3.5 h-3.5 text-slate-400" />
                    <span>Pausada</span>
                  </div>
                </td>
                <td>
                  <span class="apple-pill-badge badge-green inline-flex items-center" style="gap: 5px;" :title="'Template WATI: ' + regra.template_nome">
                    <feather-icon icon="MessageCircleIcon" svgClasses="w-3.5 h-3.5 shrink-0" />
                    <span>{{ regra.template_nome }}</span>
                  </span>
                </td>
                <td style="text-align: center;">
                  <vs-switch
                    :value="regra.ativo"
                    color="success"
                    @click="alternarStatus(regra)"
                  />
                </td>
                <td style="text-align: right;">
                  <div class="apple-action-flex">
                    <button
                      type="button"
                      class="apple-circle-btn"
                      title="Simular e ver elegíveis hoje"
                      @click="abrirSimulacaoRegra(regra.id)"
                    >
                      <feather-icon icon="PlayIcon" svgClasses="w-3.5 h-3.5 text-blue-600" />
                    </button>
                    <button
                      type="button"
                      class="apple-circle-btn"
                      title="Editar regra"
                      @click="abrirModalPosVenda(regra)"
                    >
                      <feather-icon icon="Edit2Icon" svgClasses="w-3.5 h-3.5 text-gray-600" />
                    </button>
                    <button
                      type="button"
                      class="apple-circle-btn apple-delete-btn"
                      title="Excluir regra"
                      @click="confirmarExclusao(regra)"
                    >
                      <feather-icon icon="Trash2Icon" svgClasses="w-3.5 h-3.5 text-rose-600" />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ================= ABA 2: COBRANÇA ================= -->
      <div v-else-if="abaAtiva === 1">
        <!-- Empty State Cobrança -->
        <div v-if="regrasCobranca.length === 0" class="apple-empty-container">
          <div class="apple-empty-circle">
            <feather-icon icon="InboxIcon" svgClasses="w-8 h-8 text-gray-400" />
          </div>
          <h3 class="apple-empty-heading">Nenhuma regra de cobrança configurada</h3>
          <p class="apple-empty-paragraph">
            Configure réguas de cobrança e lembretes por momento do vencimento e forma de pagamento (ex: 2 dias antes para Boleto).
          </p>
          <button
            type="button"
            class="apple-btn apple-btn-primary mt-4"
            @click="abrirModalCobranca(null)"
          >
            <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
            <span>Adicionar Primeira Regra</span>
          </button>
        </div>

        <!-- Tabela Cobrança -->
        <div v-else class="apple-table-scroll">
          <table class="apple-spacious-table">
            <thead>
              <tr>
                <th style="width: 25%;">Regra / Identificação</th>
                <th style="width: 16%;">Momento do Vencimento</th>
                <th style="width: 15%;">Forma de Pagamento</th>
                <th style="width: 18%;">Próximo Disparo</th>
                <th style="width: 14%;">Template WATI</th>
                <th style="width: 6%; text-align: center;">Status</th>
                <th style="width: 6%; text-align: right;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="regra in regrasCobranca" :key="regra.id" class="apple-table-item">
                <td>
                  <div class="apple-item-title">{{ regra.nome }}</div>
                  <div v-if="regra.equipes" class="apple-item-sub">
                    <feather-icon icon="UsersIcon" svgClasses="w-3 h-3 mr-1 inline text-gray-400" />
                    {{ regra.equipes }}
                  </div>
                </td>
                <td>
                  <span v-if="regra.tipo_periodo === 'antes'" class="apple-pill-badge badge-blue inline-flex items-center" style="gap: 5px;">
                    <feather-icon icon="BellIcon" svgClasses="w-3.5 h-3.5 shrink-0" />
                    <span>{{ regra.dias_relativo_vencimento }} dia(s) antes (A Vencer)</span>
                  </span>
                  <span v-else-if="regra.tipo_periodo === 'no_vencimento' || regra.dias_relativo_vencimento === 0" class="apple-pill-badge badge-amber inline-flex items-center" style="gap: 5px;">
                    <feather-icon icon="AlertCircleIcon" svgClasses="w-3.5 h-3.5 shrink-0" />
                    <span>No Dia do Vencimento</span>
                  </span>
                  <span v-else class="apple-pill-badge badge-rose inline-flex items-center" style="gap: 5px;">
                    <feather-icon icon="AlertTriangleIcon" svgClasses="w-3.5 h-3.5 shrink-0" />
                    <span>{{ regra.dias_relativo_vencimento }} dia(s) após (Em Atraso)</span>
                  </span>
                </td>
                <td>
                  <div v-if="obterFormasRegra(regra).length > 0" class="flex items-center flex-wrap" style="gap: 6px;">
                    <FormaPagamentoBadge
                      v-for="forma in obterFormasRegra(regra)"
                      :key="forma.id"
                      :forma="forma"
                      size="11.5"
                    />
                  </div>
                  <div v-else class="flex items-center text-slate-700 font-medium" style="gap: 8px;">
                    <feather-icon icon="CreditCardIcon" svgClasses="w-4 h-4 text-slate-400 shrink-0" />
                    <span>Todas as Formas</span>
                  </div>
                </td>
                <td>
                  <div v-if="configAutomatica.ativo && regra.ativo">
                    <div class="flex items-center text-slate-800 font-semibold text-xs" style="gap: 6px;">
                      <feather-icon icon="ZapIcon" svgClasses="w-3.5 h-3.5 text-emerald-500 shrink-0" />
                      <span>{{ calcularProximoDisparoRegra(regra).quandoTexto }}</span>
                      <span class="apple-pill-badge badge-green text-xxs" style="padding: 1px 6px;">
                        {{ calcularProximoDisparoRegra(regra).tempoFalta }}
                      </span>
                    </div>
                    <div class="text-slate-500 text-xxs mt-1">
                      {{ calcularProximoDisparoRegra(regra).alvoDescricao }}
                    </div>
                  </div>
                  <div v-else class="text-slate-400 text-xs flex items-center gap-1">
                    <feather-icon icon="PauseCircleIcon" svgClasses="w-3.5 h-3.5 text-slate-400" />
                    <span>Pausada</span>
                  </div>
                </td>
                <td>
                  <span class="apple-pill-badge badge-green" :title="'Template WATI: ' + regra.template_nome">
                    <feather-icon icon="MessageCircleIcon" svgClasses="w-3 h-3 mr-1 inline" />
                    {{ regra.template_nome }}
                  </span>
                </td>
                <td style="text-align: center;">
                  <vs-switch
                    :value="regra.ativo"
                    color="success"
                    @click="alternarStatus(regra)"
                  />
                </td>
                <td style="text-align: right;">
                  <div class="apple-action-flex">
                    <button
                      type="button"
                      class="apple-circle-btn"
                      title="Simular e ver elegíveis hoje"
                      @click="abrirSimulacaoRegra(regra.id)"
                    >
                      <feather-icon icon="PlayIcon" svgClasses="w-3.5 h-3.5 text-blue-600" />
                    </button>
                    <button
                      type="button"
                      class="apple-circle-btn"
                      title="Editar regra"
                      @click="abrirModalCobranca(regra)"
                    >
                      <feather-icon icon="Edit2Icon" svgClasses="w-3.5 h-3.5 text-gray-600" />
                    </button>
                    <button
                      type="button"
                      class="apple-circle-btn apple-delete-btn"
                      title="Excluir regra"
                      @click="confirmarExclusao(regra)"
                    >
                      <feather-icon icon="Trash2Icon" svgClasses="w-3.5 h-3.5 text-rose-600" />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ================= ABA 3: HISTÓRICO DE JOBS / BACKGROUND ================= -->
      <div v-else-if="abaAtiva === 2">
        <!-- Empty State Histórico -->
        <div v-if="historicoJobs.length === 0" class="apple-empty-container">
          <div class="apple-empty-circle">
            <feather-icon icon="ClockIcon" svgClasses="w-8 h-8 text-gray-400" />
          </div>
          <h3 class="apple-empty-heading">Nenhuma execução registrada no histórico</h3>
          <p class="apple-empty-paragraph">
            Quando os jobs da régua forem executados automaticamente pelo robô ou pelo simulador, o log de auditoria aparecerá aqui.
          </p>
          <button
            type="button"
            class="apple-btn apple-btn-primary mt-4"
            @click="abrirSimulacaoGeral"
          >
            <feather-icon icon="PlayIcon" svgClasses="w-4 h-4" />
            <span>Simular Disparo Agora</span>
          </button>
        </div>

        <!-- Tabela Histórico -->
        <div v-else class="apple-table-scroll">
          <table class="apple-spacious-table">
            <thead>
              <tr>
                <th style="width: 18%;">Data / Hora</th>
                <th style="width: 16%;">Tipo de Régua</th>
                <th style="width: 14%;">Data de Referência</th>
                <th style="width: 18%;">Elegíveis / Enviados</th>
                <th style="width: 16%;">Executado Por</th>
                <th style="width: 12%; text-align: center;">Status</th>
                <th style="width: 6%; text-align: right;">Detalhes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="job in historicoJobs" :key="job.id" class="apple-table-item">
                <td>
                  <div class="apple-item-title">{{ formatarDataHora(job.created_at) }}</div>
                  <div class="apple-item-sub font-mono">Job #{{ job.id }}</div>
                </td>
                <td>
                  <span v-if="job.tipo === 'pos_venda'" class="apple-pill-badge badge-purple">
                    Pós-Venda
                  </span>
                  <span v-else-if="job.tipo === 'cobranca'" class="apple-pill-badge badge-green">
                    Cobrança
                  </span>
                  <span v-else class="apple-pill-badge badge-blue">
                    Geral (Todas)
                  </span>
                </td>
                <td>
                  <div class="font-medium text-gray-800">{{ formatarData(job.data_referencia) }}</div>
                </td>
                <td>
                  <div class="flex items-center gap-2">
                    <span class="font-semibold text-gray-900">{{ job.total_enviados || job.total_elegiveis || 0 }} destinatário(s)</span>
                  </div>
                </td>
                <td>
                  <div class="text-xs text-gray-700 font-medium">
                    <feather-icon icon="UserIcon" svgClasses="w-3 h-3 mr-1 inline text-gray-400" />
                    {{ job.executado_por || 'Robô Automático' }}
                  </div>
                </td>
                <td style="text-align: center;">
                  <span v-if="job.status === 'concluido'" class="apple-pill-badge badge-green">
                    Concluído
                  </span>
                  <span v-else-if="job.status === 'sem_destinatarios'" class="apple-pill-badge badge-gray">
                    Sem Destinatários
                  </span>
                  <span v-else-if="job.status === 'em_execucao'" class="apple-pill-badge badge-blue">
                    Em Execução
                  </span>
                  <span v-else class="apple-pill-badge badge-rose">
                    Falha
                  </span>
                </td>
                <td style="text-align: right;">
                  <button
                    type="button"
                    class="apple-circle-btn"
                    title="Ver detalhes do job"
                    @click="abrirDetalheJob(job)"
                  >
                    <feather-icon icon="EyeIcon" svgClasses="w-3.5 h-3.5 text-gray-600" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- Modal Detalhe do Job Histórico (Visualização em Tabela e Cards) -->
    <vs-popup
      title="Detalhes da Execução do Job"
      :active.sync="modalDetalheJob"
      class="modal-detalhe-job-popup"
    >
      <div v-if="jobSelecionado" class="modal-job-body">
        <!-- Cabeçalho do Job -->
        <div class="modal-job-header">
          <div>
            <div class="flex items-center gap-2">
              <span class="modal-job-id-pill">Job #{{ jobSelecionado.id }}</span>
              <span class="modal-job-timestamp">{{ formatarDataHora(jobSelecionado.created_at) }}</span>
            </div>
          </div>
          <span 
            class="apple-pill-badge"
            :class="obterStatusJobClass(jobSelecionado.status)"
          >
            <feather-icon 
              :icon="jobSelecionado.status === 'concluido' ? 'CheckCircleIcon' : (jobSelecionado.status === 'simulado_dry_run' ? 'PlayIcon' : 'InfoIcon')" 
              svgClasses="w-3 h-3 mr-1 inline" 
            />
            {{ obterStatusJobLabel(jobSelecionado.status) }}
          </span>
        </div>

        <!-- Grid de Metadados / Resumo -->
        <div class="modal-job-meta-grid mt-4">
          <div class="modal-meta-card">
            <span class="modal-meta-label">Tipo de Régua</span>
            <div class="modal-meta-value mt-1.5">
              <span v-if="jobSelecionado.tipo === 'pos_venda'" class="apple-pill-badge badge-purple text-xs">Pós-Venda</span>
              <span v-else-if="jobSelecionado.tipo === 'cobranca'" class="apple-pill-badge badge-green text-xs">Cobrança</span>
              <span v-else class="apple-pill-badge badge-blue text-xs">Geral (Todas)</span>
            </div>
          </div>

          <div class="modal-meta-card">
            <span class="modal-meta-label">Data de Referência</span>
            <div class="modal-meta-value font-medium text-slate-800 flex items-center mt-1.5">
              <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4 mr-1.5 inline text-slate-400" />
              <span>{{ formatarData(jobSelecionado.data_referencia) }}</span>
            </div>
          </div>

          <div class="modal-meta-card">
            <span class="modal-meta-label">Destinatários Processados</span>
            <div class="modal-meta-value font-bold text-emerald-700 mt-1.5" style="font-size: 15px;">
              {{ jobSelecionado.total_enviados || jobSelecionado.total_elegiveis || 0 }} <span class="font-normal text-xs text-slate-500">destinatário(s)</span>
            </div>
          </div>

          <div class="modal-meta-card">
            <span class="modal-meta-label">Executado Por</span>
            <div class="modal-meta-value text-slate-700 text-xs mt-1.5 flex items-center" :title="jobSelecionado.executado_por">
              <feather-icon icon="UserIcon" svgClasses="w-3.5 h-3.5 mr-1.5 inline text-slate-400 shrink-0" />
              <span class="font-medium text-slate-800 truncate">{{ jobSelecionado.executado_por || 'Robô Automático' }}</span>
            </div>
          </div>
        </div>

        <!-- Tabela Estruturada de Regras Acionadas -->
        <div class="modal-job-section mt-5">
          <div class="flex items-center justify-between mb-2">
            <h4 class="modal-section-title">Regras Acionadas nesta Execução</h4>
            <span class="text-xs text-slate-500 font-medium">
              {{ detalhesJobSelecionado.jobs.length }} regra(s) processada(s)
            </span>
          </div>

          <!-- Caso haja regras acionadas -->
          <div v-if="detalhesJobSelecionado.jobs.length > 0" class="modal-table-container">
            <table class="modal-table">
              <thead>
                <tr>
                  <th style="width: 35%;">Regra / Identificação</th>
                  <th style="width: 25%;">Template WATI</th>
                  <th style="width: 20%; text-align: center;">Elegíveis</th>
                  <th style="width: 20%; text-align: right;">Canal</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(itemJob, idx) in detalhesJobSelecionado.jobs" :key="'job-item-' + idx">
                  <td>
                    <div class="font-semibold text-slate-900 text-xs">{{ itemJob.nomeRegra || itemJob.nome || 'Regra de Disparo' }}</div>
                    <div class="text-slate-400 text-xxs mt-0.5">ID #{{ itemJob.idRegra || '-' }}</div>
                  </td>
                  <td>
                    <span class="apple-pill-badge badge-green text-xs" :title="'Template: ' + (itemJob.templateNome || itemJob.template_nome)">
                      <feather-icon icon="MessageCircleIcon" svgClasses="w-3 h-3 mr-1 inline" />
                      {{ itemJob.templateNome || itemJob.template_nome || 'Padrão' }}
                    </span>
                  </td>
                  <td style="text-align: center;">
                    <span class="font-bold text-slate-900 text-xs">
                      {{ itemJob.totalElegiveis || itemJob.total_elegiveis || (itemJob.destinatarios ? itemJob.destinatarios.length : 0) }}
                    </span>
                  </td>
                  <td style="text-align: right;">
                    <span class="apple-pill-badge badge-blue text-xs uppercase font-medium">
                      {{ itemJob.canal || 'WhatsApp' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Empty State quando nenhuma regra precisou disparar -->
          <div v-else class="modal-table-empty">
            <div class="modal-empty-icon-box">
              <feather-icon icon="CheckCircleIcon" svgClasses="w-6 h-6 text-slate-400" />
            </div>
            <div class="font-semibold text-xs text-slate-700">Nenhum envio necessário</div>
            <p class="text-xxs text-slate-500 max-w-sm mt-0.5 mb-0">
              O robô avaliou todas as regras para a data informada, mas nenhum cliente atingiu os critérios de gatilho hoje.
            </p>
          </div>
        </div>

        <!-- Rodapé do Modal com Botão Dropdown Estilizado e Ações -->
        <div class="modal-job-footer">
          <button
            type="button"
            class="apple-json-toggle-btn"
            :class="{ 'active': mostrarJsonTecnico }"
            @click="mostrarJsonTecnico = !mostrarJsonTecnico"
          >
            <div class="apple-json-toggle-icon">
              <feather-icon icon="CodeIcon" svgClasses="w-3.5 h-3.5" />
            </div>
            <span>{{ mostrarJsonTecnico ? 'Ocultar Detalhes Técnicos' : 'Ver Dados Técnicos (JSON)' }}</span>
            <feather-icon :icon="mostrarJsonTecnico ? 'ChevronUpIcon' : 'ChevronDownIcon'" svgClasses="w-4 h-4 ml-1 text-slate-400" />
          </button>

          <button 
            type="button" 
            class="apple-btn-modal-close"
            @click="modalDetalheJob = false"
          >
            Fechar
          </button>
        </div>

        <div v-if="mostrarJsonTecnico" class="mt-3 bg-slate-900 text-slate-100 p-4 rounded-xl text-xxs font-mono max-h-48 overflow-y-auto border border-slate-800 shadow-inner">
          <pre style="margin: 0; white-space: pre-wrap;">{{ formatarDetalhesJson(jobSelecionado.detalhes) }}</pre>
        </div>
      </div>
    </vs-popup>

    <!-- Modais Apple Style -->
    <modal-regra-pos-venda
      :active.sync="modalPosVendaAtivo"
      :regra="regraSelecionada"
      :templates="templatesWati"
      :loading-templates="carregandoTemplates"
      @salvo="recarregarTudo"
      @sincronizar-templates="carregarTemplatesWati"
    />

    <modal-regra-cobranca
      :active.sync="modalCobrancaAtivo"
      :regra="regraSelecionada"
      :templates="templatesWati"
      :formas-pagamento="formasPagamento"
      :loading-templates="carregandoTemplates"
      @salvo="recarregarTudo"
      @sincronizar-templates="carregarTemplatesWati"
    />

    <modal-simulacao-regra
      :active.sync="modalSimulacaoAtivo"
      :id-regra="idRegraSimulacao"
      :tipo="tipoSimulacao"
      @disparado="recarregarTudo"
    />
  </div>
</template>

<script>
import ModalRegraPosVenda from "./components/modalRegraPosVenda.vue";
import ModalRegraCobranca from "./components/modalRegraCobranca.vue";
import ModalSimulacaoRegra from "./components/modalSimulacaoRegra.vue";

export default {
  name: "ReguaDisparos",
  components: {
    ModalRegraPosVenda,
    ModalRegraCobranca,
    ModalSimulacaoRegra
  },
  data() {
    return {
      abaAtiva: 0,
      carregando: false,
      carregandoTemplates: false,
      carregandoHistorico: false,
      salvandoConfigAutomatica: false,
      regras: [],
      historicoJobs: [],
      templatesWati: [],
      formasPagamento: [],
      
      // Robô Automático em Background
      configAutomatica: {
        ativo: true,
        horario: '08:30',
        dias: [1, 2, 3, 4, 5],
        excluirFeriados: true,
        ultimaExecucao: null
      },
      tipoFrequencia: 'uteis_sem_feriados',

      // Controle dos Modais
      modalPosVendaAtivo: false,
      modalCobrancaAtivo: false,
      modalSimulacaoAtivo: false,
      modalDetalheJob: false,
      mostrarJsonTecnico: false,
      jobSelecionado: null,
      regraSelecionada: null,
      idRegraSimulacao: null,
      tipoSimulacao: null
    };
  },
  computed: {
    regrasPosVenda() {
      if (!Array.isArray(this.regras)) return [];
      return this.regras.filter(function(r) { return r.tipo === 'pos_venda'; });
    },
    regrasCobranca() {
      if (!Array.isArray(this.regras)) return [];
      return this.regras.filter(function(r) { return r.tipo === 'cobranca'; });
    },
    totalAtivasPosVenda() {
      return this.regrasPosVenda.filter(function(r) { return r.ativo; }).length;
    },
    totalAtivasCobranca() {
      return this.regrasCobranca.filter(function(r) { return r.ativo; }).length;
    },
    detalhesJobSelecionado() {
      if (!this.jobSelecionado || !this.jobSelecionado.detalhes) {
        return { dryRun: false, limite: null, jobs: [] };
      }
      let det = this.jobSelecionado.detalhes;
      if (typeof det === 'string') {
        try {
          det = JSON.parse(det);
        } catch (_) {
          det = { raw: det, jobs: [] };
        }
      }
      return {
        dryRun: Boolean(det && det.dryRun),
        limite: det && det.limite ? det.limite : null,
        jobs: det && Array.isArray(det.jobs) ? det.jobs : []
      };
    }
  },
  watch: {
    '$route.query.tab'() {
      this.verificarAbaUrl();
    }
  },
  mounted() {
    this.verificarAbaUrl();
    this.recarregarTudo();
    this.carregarConfigAutomatica();
    this.carregarTemplatesWati();
    this.carregarFormasPagamento();
  },
  methods: {
    obterStatusJobLabel(status) {
      if (status === 'concluido') return 'Concluído';
      if (status === 'simulado_dry_run') return 'Simulação (Dry-Run)';
      if (status === 'sem_destinatarios') return 'Sem Destinatários';
      if (status === 'em_execucao') return 'Em Execução';
      return 'Falha';
    },
    obterStatusJobClass(status) {
      if (status === 'concluido') return 'badge-green';
      if (status === 'simulado_dry_run') return 'badge-blue';
      if (status === 'sem_destinatarios') return 'badge-gray';
      if (status === 'em_execucao') return 'badge-blue';
      return 'badge-rose';
    },
    verificarAbaUrl() {
      const tab = this.$route && this.$route.query ? this.$route.query.tab : null;
      if (tab === 'cobranca') {
        this.abaAtiva = 1;
      } else if (tab === 'historico') {
        this.abaAtiva = 2;
      } else {
        this.abaAtiva = 0;
      }
    },
    async recarregarTudo() {
      await Promise.all([
        this.carregarRegras(),
        this.carregarHistorico()
      ]);
    },
    async carregarConfigAutomatica() {
      try {
        const res = await this.$http.get('regua-disparos/configuracao-automatica');
        const config = res && res.data ? res.data : res;
        if (config) {
          this.configAutomatica.ativo = !!config.ativo;
          this.configAutomatica.horario = config.horario || '08:30';
          this.configAutomatica.dias = Array.isArray(config.dias) ? config.dias : [1, 2, 3, 4, 5];
          this.configAutomatica.excluirFeriados = config.excluirFeriados !== undefined ? !!config.excluirFeriados : false;
          this.configAutomatica.ultimaExecucao = config.ultimaExecucao || null;
          
          if (this.configAutomatica.dias.length >= 7) {
            this.tipoFrequencia = 'todos';
          } else if (this.configAutomatica.excluirFeriados) {
            this.tipoFrequencia = 'uteis_sem_feriados';
          } else {
            this.tipoFrequencia = 'uteis';
          }
        }
      } catch (err) {
        console.warn("Erro ao buscar configuração automática do robô:", err);
      }
    },
    async salvarConfigAutomatica() {
      this.salvandoConfigAutomatica = true;
      try {
        const dias = this.tipoFrequencia === 'todos' 
          ? [0, 1, 2, 3, 4, 5, 6] 
          : [1, 2, 3, 4, 5];
        const excluirFeriados = this.tipoFrequencia === 'uteis_sem_feriados';

        await this.$http.post('regua-disparos/configuracao-automatica', {
          ativo: this.configAutomatica.ativo,
          horario: this.configAutomatica.horario,
          dias: dias,
          excluirFeriados: excluirFeriados
        });

        const freqDesc = this.tipoFrequencia === 'todos'
          ? 'Todos os dias'
          : (this.tipoFrequencia === 'uteis_sem_feriados' ? 'Seg a Sex (excluindo feriados)' : 'Dias úteis (Seg a Sex)');

        this.$vs.notify({
          title: "Robô Automático Atualizado",
          text: `Agendamento salvo para ${this.configAutomatica.horario} (${freqDesc}).`,
          color: "success"
        });
      } catch (err) {
        const error = this.$httpErrors ? this.$httpErrors(err) : { text: err.message };
        this.$vs.notify({
          title: "Erro ao salvar",
          text: error.text || err.message,
          color: "danger"
        });
      } finally {
        this.salvandoConfigAutomatica = false;
      }
    },
    async carregarRegras() {
      this.carregando = true;
      try {
        const res = await this.$http.get('regua-disparos');
        this.regras = res && res.data ? res.data : (Array.isArray(res) ? res : []);
      } catch (err) {
        const error = this.$httpErrors ? this.$httpErrors(err) : { text: err.message };
        this.$vs.notify({
          title: "Erro ao carregar regras",
          text: error.text || err.message,
          color: "danger"
        });
      } finally {
        this.carregando = false;
      }
    },
    async carregarHistorico() {
      this.carregandoHistorico = true;
      try {
        const res = await this.$http.get('regua-disparos/historico');
        this.historicoJobs = res && res.data ? res.data : (Array.isArray(res) ? res : []);
      } catch (err) {
        console.warn("Erro ao buscar histórico de jobs da régua:", err);
      } finally {
        this.carregandoHistorico = false;
      }
    },
    async carregarTemplatesWati() {
      this.carregandoTemplates = true;
      try {
        const res = await this.$http.get('getWatiTemplates');
        const raw = res && res.data ? res.data : res;
        const lista = raw && raw.data ? raw.data : (raw && raw.messageTemplates ? raw.messageTemplates : raw);
        this.templatesWati = Array.isArray(lista) ? lista : [];
      } catch (err) {
        console.warn("Erro ao buscar templates do WATI:", err);
      } finally {
        this.carregandoTemplates = false;
      }
    },
    async carregarFormasPagamento() {
      try {
        const res = await this.$http.get('formasPagamento');
        this.formasPagamento = res && res.data ? res.data : (Array.isArray(res) ? res : []);
      } catch (err) {
        console.warn("Erro ao buscar formas de pagamento:", err);
      }
    },
    obterFormasRegra(regra) {
      if (!regra) return [];
      const idsStr = regra.ids_formas_pagamento || (regra.id_forma_pagamento ? String(regra.id_forma_pagamento) : null);
      if (!idsStr) return [];
      const ids = idsStr.split(',').map(n => Number(n.trim())).filter(n => !isNaN(n) && n > 0);
      if (!this.formasPagamento || this.formasPagamento.length === 0) {
        if (regra.formaPagamento) return [regra.formaPagamento];
        return ids.map(id => ({ id, nome: 'Forma #' + id }));
      }
      const encontradas = this.formasPagamento.filter(f => ids.indexOf(Number(f.id)) !== -1);
      if (encontradas.length > 0) return encontradas;
      if (regra.formaPagamento) return [regra.formaPagamento];
      return [];
    },
    calcularProximoDisparoRegra(regra) {
      if (!regra || !regra.ativo || !this.configAutomatica.ativo) {
        return {
          quandoTexto: 'Pausada',
          tempoFalta: null,
          alvoDescricao: 'Robô ou regra desativada'
        };
      }

      const horarioStr = this.configAutomatica.horario || '09:00';
      const parts = horarioStr.split(':');
      const horaConfig = parseInt(parts[0], 10) || 9;
      const minConfig = parseInt(parts[1], 10) || 0;

      const agora = new Date();
      const hojeDisparo = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate(), horaConfig, minConfig, 0);

      let proximaData = new Date(hojeDisparo.getTime());
      let ehHoje = false;

      if (agora.getTime() < hojeDisparo.getTime()) {
        ehHoje = true;
      } else {
        proximaData.setDate(proximaData.getDate() + 1);
      }

      if (this.tipoFrequencia === 'uteis' || this.tipoFrequencia === 'uteis_sem_feriados') {
        const diaSemana = proximaData.getDay();
        if (diaSemana === 6) {
          proximaData.setDate(proximaData.getDate() + 2);
          ehHoje = false;
        } else if (diaSemana === 0) {
          proximaData.setDate(proximaData.getDate() + 1);
          ehHoje = false;
        }
      }

      const diffMs = proximaData.getTime() - agora.getTime();
      const diffHoras = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMin = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      let tempoFaltaStr = '';
      if (diffHoras >= 24) {
        const dias = Math.floor(diffHoras / 24);
        tempoFaltaStr = `em ${dias}d ${diffHoras % 24}h`;
      } else if (diffHoras > 0) {
        tempoFaltaStr = `em ${diffHoras}h ${diffMin}m`;
      } else {
        tempoFaltaStr = `em ${diffMin > 0 ? diffMin : 1}m`;
      }

      const quandoTexto = ehHoje ? `Hoje às ${horarioStr}` : `Amanhã às ${horarioStr}`;

      let alvoDescricao = '';
      const dataAvaliacao = new Date(proximaData.getTime());

      if (regra.tipo === 'pos_venda') {
        const diasApos = Number(regra.dias_apos_execucao || 0);
        const dataOsAlvo = new Date(dataAvaliacao.getTime());
        dataOsAlvo.setDate(dataOsAlvo.getDate() - diasApos);
        const dia = String(dataOsAlvo.getDate()).padStart(2, '0');
        const mes = String(dataOsAlvo.getMonth() + 1).padStart(2, '0');
        alvoDescricao = `Alvo: OSs de ${dia}/${mes}`;
      } else {
        const tipo = regra.tipo_periodo || 'apos';
        const dias = Number(regra.dias_relativo_vencimento || 0);
        const dataContaAlvo = new Date(dataAvaliacao.getTime());
        if (tipo === 'antes') {
          dataContaAlvo.setDate(dataContaAlvo.getDate() + dias);
        } else if (tipo === 'no_vencimento' || dias === 0) {
          // mantém
        } else {
          dataContaAlvo.setDate(dataContaAlvo.getDate() - dias);
        }
        const dia = String(dataContaAlvo.getDate()).padStart(2, '0');
        const mes = String(dataContaAlvo.getMonth() + 1).padStart(2, '0');
        alvoDescricao = `Alvo: Vencimento ${dia}/${mes}`;
      }

      return {
        quandoTexto: quandoTexto,
        tempoFalta: tempoFaltaStr,
        alvoDescricao: alvoDescricao
      };
    },
    formatarData(dt) {
      if (!dt) return '-';
      const parts = dt.split('-');
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return dt;
    },
    formatarDataHora(dt) {
      if (!dt) return '-';
      const d = new Date(dt);
      return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    formatarDetalhesJson(det) {
      if (!det) return 'Sem detalhes adicionais.';
      try {
        if (typeof det === 'string') {
          return JSON.stringify(JSON.parse(det), null, 2);
        }
        return JSON.stringify(det, null, 2);
      } catch (_) {
        return String(det);
      }
    },
    abrirDetalheJob(job) {
      this.jobSelecionado = job;
      this.modalDetalheJob = true;
    },
    abrirNovaRegra() {
      if (this.abaAtiva === 0) {
        this.abrirModalPosVenda(null);
      } else {
        this.abrirModalCobranca(null);
      }
    },
    abrirModalPosVenda(regra) {
      this.regraSelecionada = regra;
      this.modalPosVendaAtivo = true;
    },
    abrirModalCobranca(regra) {
      this.regraSelecionada = regra;
      this.modalCobrancaAtivo = true;
    },
    abrirSimulacaoRegra(idRegra) {
      this.idRegraSimulacao = idRegra;
      this.tipoSimulacao = null;
      this.modalSimulacaoAtivo = true;
    },
    abrirSimulacaoGeral() {
      this.idRegraSimulacao = null;
      this.tipoSimulacao = this.abaAtiva === 0 ? 'pos_venda' : 'cobranca';
      this.modalSimulacaoAtivo = true;
    },
    async alternarStatus(regra) {
      try {
        const res = await this.$http.patch(`regua-disparos/${regra.id}/toggle`);
        const regraAtualizada = res && res.data ? res.data : res;
        regra.ativo = regraAtualizada.ativo;
        this.$vs.notify({
          title: "Status Atualizado",
          text: `Regra ${regra.ativo ? 'ativada' : 'desativada'} com sucesso!`,
          color: "success"
        });
      } catch (err) {
        const error = this.$httpErrors ? this.$httpErrors(err) : { text: err.message };
        this.$vs.notify({
          title: "Erro ao alterar status",
          text: error.text || err.message,
          color: "danger"
        });
      }
    },
    confirmarExclusao(regra) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: `Deseja realmente excluir a regra "${regra.nome}"?`,
        acceptText: 'Excluir',
        cancelText: 'Cancelar',
        accept: async () => {
          try {
            await this.$http.delete(`regua-disparos/${regra.id}`);
            this.$vs.notify({
              title: "Sucesso",
              text: "Regra excluída com sucesso!",
              color: "success"
            });
            this.recarregarTudo();
          } catch (err) {
            const error = this.$httpErrors ? this.$httpErrors(err) : { text: err.message };
            this.$vs.notify({
              title: "Erro ao excluir",
              text: error.text || err.message,
              color: "danger"
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>
/* =========================================================
   Apple Human Interface Guidelines & Modern ERP Design
========================================================= */
.apple-page-container {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Segoe UI", Roboto, sans-serif;
  color: #0f172a;
  width: 100%;
  padding: 8px 12px 24px;
}

/* Card Principal */
.apple-main-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 24px 28px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03), 0 1px 2px -1px rgba(0, 0, 0, 0.02);
}

.apple-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.apple-main-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0;
}

.apple-pill-tag {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 3px 10px;
  border-radius: 100px;
  background: #eff6ff;
  color: #0284c7;
  border: 1px solid #bae6fd;
}

.apple-main-subtitle {
  font-size: 13.5px;
  color: #64748b;
  margin-top: 4px;
  margin-bottom: 0;
  line-height: 1.4;
}

.apple-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* Botões Apple */
.apple-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(0.16, 1, 0.3, 1);
  border: none;
  text-decoration: none;
  outline: none;
  height: 38px;
}

.apple-btn-primary {
  background: linear-gradient(180deg, #0284c7 0%, #0369a1 100%);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(2, 132, 199, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}
.apple-btn-primary:hover {
  background: linear-gradient(180deg, #0369a1 0%, #075985 100%);
  box-shadow: 0 4px 10px rgba(2, 132, 199, 0.3);
  transform: translateY(-1px);
}

.apple-btn-secondary {
  background: #ffffff;
  color: #334155;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.apple-btn-secondary:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}

/* Grid de Métricas / KPI Cards */
.apple-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 1100px) {
  .apple-kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .apple-kpi-grid {
    grid-template-columns: 1fr;
  }
}

.apple-kpi-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px 20px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
}

.apple-kpi-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 6px 16px -2px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}

.apple-kpi-card.kpi-card-active {
  border-color: #0284c7;
  box-shadow: 0 0 0 2px rgba(2, 132, 199, 0.18), 0 4px 12px rgba(0, 0, 0, 0.04);
}

.apple-kpi-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.apple-kpi-title {
  font-size: 11.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.apple-kpi-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apple-kpi-body {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.apple-kpi-number {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #0f172a;
}

.apple-kpi-desc {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.kpi-status-badge {
  font-size: 12px;
}
.kpi-status-badge.badge-active {
  color: #059669;
}
.kpi-status-badge.badge-inactive {
  color: #94a3b8;
}

/* =========================================================
   Barra do Robô Automático Refinada
========================================================= */
.apple-robot-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px 20px;
}

.apple-robot-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}

.apple-robot-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.apple-robot-icon {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.robot-icon-active {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}

.robot-icon-inactive {
  background: #e2e8f0;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

.apple-robot-texts {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.apple-robot-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.apple-robot-name {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

/* Pill de Status do Robô */
.robot-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 100px;
  transition: all 0.2s ease;
}

.status-pill-active {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.status-pill-inactive {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

/* Ponto de Pulso Animado */
.status-pulse-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
}

.pulse-green {
  background-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25);
  animation: pulseEffect 2s infinite ease-in-out;
}

.pulse-gray {
  background-color: #94a3b8;
}

@keyframes pulseEffect {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6); }
  70% { transform: scale(1); box-shadow: 0 0 0 5px rgba(16, 185, 129, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
}

.apple-robot-desc {
  font-size: 12px;
  color: #64748b;
}

/* Controles do Robô */
.apple-robot-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.robot-input-group {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  padding: 4px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  height: 36px;
}

.robot-input-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin: 0;
}

.apple-time-input {
  border: none;
  font-size: 12.5px;
  font-weight: 600;
  color: #0f172a;
  outline: none;
  background: transparent;
  width: 70px;
}

.apple-select-input {
  border: none;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  outline: none;
  background: transparent;
  cursor: pointer;
}

.robot-switch-wrapper {
  display: flex;
  align-items: center;
  padding: 0 4px;
}

.apple-btn-save-robot {
  background: #0f172a;
  color: #ffffff;
  padding: 7px 16px;
  font-size: 12.5px;
  height: 36px;
}
.apple-btn-save-robot:hover {
  background: #1e293b;
  transform: translateY(-1px);
}

/* Toolbar & Segmented Tabs */
.apple-toolbar-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
}

.apple-segmented-bar {
  display: inline-flex;
  background: #e2e8f0;
  padding: 4px;
  border-radius: 12px;
  gap: 4px;
}

.apple-tab-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  background: transparent;
  border: none;
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.18s ease;
}

.apple-tab-button.active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.apple-count-pill {
  font-size: 11px;
  font-weight: 700;
  padding: 1px 7px;
  border-radius: 100px;
  margin-left: 6px;
  background: #f1f5f9;
  color: #64748b;
}

.apple-tab-button.active .apple-count-pill {
  background: #e0f2fe;
  color: #0284c7;
}

.apple-refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  padding: 7px 16px;
  cursor: pointer;
  transition: all 0.15s ease;
  height: 36px;
}
.apple-refresh-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

/* Tabela Apple */
.apple-table-scroll {
  overflow-x: auto;
}

.apple-spacious-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.apple-spacious-table th {
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  background: #f8fafc;
}

.apple-spacious-table td {
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.apple-table-item:hover {
  background-color: #f8fafc;
}

.apple-table-item:last-child td {
  border-bottom: none;
}

.apple-item-title {
  font-weight: 600;
  color: #0f172a;
  font-size: 13.5px;
}

.apple-item-sub {
  font-size: 11.5px;
  color: #94a3b8;
  margin-top: 2px;
}

/* Badges Pílula */
.apple-pill-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 100px;
}

.badge-purple {
  background: #f5f3ff;
  color: #7c3aed;
  border: 1px solid #ddd6fe;
}

.badge-green {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.badge-blue {
  background: #eff6ff;
  color: #0284c7;
  border: 1px solid #bae6fd;
}

.badge-amber {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #fde68a;
}

.badge-rose {
  background: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
}

.badge-gray {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

/* Ações */
.apple-action-flex {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.apple-circle-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.apple-circle-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.apple-delete-btn:hover {
  background: #fff1f2;
  border-color: #fecdd3;
}

/* Empty State */
.apple-empty-container {
  text-align: center;
  padding: 60px 24px;
}

.apple-empty-circle {
  width: 60px;
  height: 60px;
  border-radius: 18px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.apple-empty-heading {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.apple-empty-paragraph {
  font-size: 13.5px;
  color: #64748b;
  max-width: 480px;
  margin: 0 auto;
}

/* =========================================================
   Skeleton Shimmer Wave Animations
========================================================= */
.skeleton-card {
  pointer-events: none;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 37%, #f1f5f9 63%);
  background-size: 400% 100%;
  animation: shimmerWave 1.4s ease infinite;
}

@keyframes shimmerWave {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.apple-table-skeleton-container {
  padding: 8px;
}

.skeleton-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  margin-bottom: 12px;
}

.skeleton-table-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px;
  border-bottom: 1px solid #f1f5f9;
}

/* =========================================================
   Modal de Detalhes do Job (Tabela e Cards)
========================================================= */
.modal-detalhe-job-popup >>> .vs-popup {
  max-width: 880px;
  width: 95%;
  border-radius: 16px;
}

.modal-job-body {
  padding: 6px 6px 12px;
}

.modal-job-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
}

.modal-job-id-pill {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.modal-job-timestamp {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.modal-job-meta-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

@media (min-width: 640px) {
  .modal-job-meta-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.modal-meta-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 16px;
  min-height: 82px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.modal-meta-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
}

.modal-meta-value {
  font-size: 13px;
}

.modal-job-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #f1f5f9;
  gap: 16px;
  flex-wrap: wrap;
}

.apple-json-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #334155;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}

.apple-json-toggle-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
  color: #0f172a;
}

.apple-json-toggle-btn.active {
  background: #e2e8f0;
  border-color: #94a3b8;
  color: #0f172a;
}

.apple-json-toggle-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apple-btn-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 24px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}

.apple-btn-modal-close:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}

.modal-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.modal-table-container {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.modal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.modal-table th {
  background: #f8fafc;
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

.modal-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.modal-table tr:last-child td {
  border-bottom: none;
}

.modal-table tr:hover td {
  background: #f8fafc;
}

.modal-table-empty {
  text-align: center;
  padding: 24px 16px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
}

.modal-empty-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.text-xxs {
  font-size: 10.5px;
}
</style>

<style>
/* =========================================================
   Estilos Globais dos Modais da Régua (Vuesax Popup)
========================================================= */
.apple-modal .vs-popup--header,
.modal-detalhe-job-popup .vs-popup--header {
  padding: 16px 24px !important;
  background: #ffffff !important;
  background-color: #ffffff !important;
  border-bottom: 1px solid #f1f5f9 !important;
  border-radius: 18px 18px 0 0 !important;
}

.apple-modal .vs-popup--title h3,
.apple-modal .vs-popup--header h3,
.modal-detalhe-job-popup .vs-popup--title h3,
.modal-detalhe-job-popup .vs-popup--header h3 {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  letter-spacing: -0.01em !important;
}

.apple-modal .vs-popup--close,
.modal-detalhe-job-popup .vs-popup--close {
  background: #f1f5f9 !important;
  color: #64748b !important;
  border-radius: 8px !important;
  padding: 4px !important;
  top: 14px !important;
  right: 18px !important;
  transition: all 0.15s ease !important;
}

.apple-modal .vs-popup--close:hover,
.modal-detalhe-job-popup .vs-popup--close:hover {
  background: #fee2e2 !important;
  color: #ef4444 !important;
}

.modal-detalhe-job-popup .vs-popup {
  max-width: 900px !important;
  width: 95% !important;
  border-radius: 18px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.modal-detalhe-job-popup .vs-popup--content {
  padding: 20px 24px 24px !important;
}
</style>


